/**
 * Catálogo de las pantallas de SLAD, en el mismo orden y con los mismos nombres que el menú
 * de SLAD VISIBILITY. De acá salen el sidebar, las rutas y el catálogo de perfiles: una sola
 * lista que mantener.
 */
export interface ReporteSlad {
  /** Código de la ruta (sin el / inicial) y de PERFIL_OPCION. */
  codigo: string;
  titulo: string;
  /** Submenú al que pertenece; sin grupo va en el primer nivel. */
  grupo?: string;
  /** Icono de Material para el primer nivel. */
  icono?: string;
  /** Abreviatura que el sidebar muestra en los hijos de un submenú. */
  ab?: string;
}

/**
 * Cuántas filas muestra una grilla antes de paginar. Vale para TODAS las tablas del portal,
 * no solo las de SLAD: es una decisión del usuario, no un detalle de esta pantalla.
 */
export const FILAS_POR_PAGINA = 15;

/** Icono de cada submenú, en el mismo criterio que el resto del menú. */
export const ICONOS_GRUPO_SLAD = {
  'Operaciones de CD': 'event_available',
  'Trazabilidad': 'timeline',
  'Indicadores de Gestión': 'trending_up',
  'Puntos de Entrega': 'place',
  'Ingreso de Pedidos': 'add_shopping_cart'
};

/** Submenús, en el orden en que aparecen dentro del menú. */
export const GRUPOS_SLAD = {
  OPERACIONES: 'Operaciones de CD',
  TRAZABILIDAD: 'Trazabilidad',
  INDICADORES: 'Indicadores de Gestión',
  PUNTOS: 'Puntos de Entrega',
  PEDIDOS: 'Ingreso de Pedidos'
};

export const REPORTES_SLAD: ReporteSlad[] = [
  { codigo: 'slad-stock-sku', titulo: 'Stock Resumido por SKU', icono: 'inventory_2' },
  { codigo: 'slad-stock-pallet', titulo: 'Stock Detallado por Pallet', icono: 'widgets' },
  { codigo: 'slad-stock-retencion', titulo: 'Stock por Causa de Retención', icono: 'block' },
  { codigo: 'slad-stock-liberaciones-ova', titulo: 'Stock Liberaciones por OVA', icono: 'lock_open' },
  { codigo: 'slad-movimiento-resumido', titulo: 'Movimiento de Productos - Resumido', icono: 'swap_horiz' },
  { codigo: 'slad-movimiento-detallado', titulo: 'Movimiento de Productos - Detallado', icono: 'compare_arrows' },
  { codigo: 'slad-movimiento-pallet', titulo: 'Movimiento Detallado de Pallet', icono: 'sync_alt' },
  { codigo: 'slad-ajustes-productos', titulo: 'Informe de Ajustes de Productos', icono: 'tune' },
  { codigo: 'slad-pallets-sin-movimientos', titulo: 'Detalle de Pallets sin Movimientos', icono: 'hourglass_empty' },

  { codigo: 'slad-planificacion-ova', titulo: 'Planificacion de Ova', grupo: GRUPOS_SLAD.OPERACIONES, ab: 'PO' },

  { codigo: 'slad-productividad-cajas', titulo: 'Consulta Productividad E/S de Cajas', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'PC' },
  { codigo: 'slad-pedidos-despachados', titulo: 'Pedidos Despachados', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'PD' },
  { codigo: 'slad-pedido-documento', titulo: 'Pedido/Documento', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'PDo' },
  { codigo: 'slad-pedidos-periodo', titulo: 'Pedidos por Periodo', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'PP' },
  { codigo: 'slad-pedidos-sin-ruta', titulo: 'Pedidos Sin Resultado de Rutas', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'PSR' },
  { codigo: 'slad-documentos-no-retornados', titulo: 'Documentos No Retornados', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'DNR' },
  { codigo: 'slad-danos-grp', titulo: 'Daños en GRP', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'DG' },
  { codigo: 'slad-trazabilidad-lote', titulo: 'Trazabilidad por Lote', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'TL' },
  { codigo: 'slad-cajas-en-stock', titulo: 'Detalle de Cajas en Stock', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'DCS' },
  { codigo: 'slad-movimientos-inventario', titulo: 'Movimientos de Inventario', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'MI' },
  { codigo: 'slad-retenciones-liberaciones', titulo: 'Retenciones Liberaciones de Pallets', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'RLP' },
  { codigo: 'slad-historico-camiones', titulo: 'Histórico Entrada/Salida Camiones', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'HC' },
  { codigo: 'slad-analisis-movimientos', titulo: 'Análisis de Movimientos de Inventario', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'AMI' },
  { codigo: 'slad-cajas-escaneadas', titulo: 'Detalle de Cajas Escaneadas', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'DCE' },
  { codigo: 'slad-pedidos-con-ruta', titulo: 'Pedidos con Resultado Ruta', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'PRR' },
  { codigo: 'slad-cambios-estado', titulo: 'Cambios de Estado', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'CE' },
  { codigo: 'slad-consulta-liberaciones', titulo: 'Consulta de Liberaciones', grupo: GRUPOS_SLAD.TRAZABILIDAD, ab: 'CL' },

  { codigo: 'slad-kpi-otif', titulo: 'KPI OTIF / ON TIME / IN FULL', grupo: GRUPOS_SLAD.INDICADORES, ab: 'OT' },
  { codigo: 'slad-rotacion-sku', titulo: 'Rotación x SKU', grupo: GRUPOS_SLAD.INDICADORES, ab: 'RS' },
  { codigo: 'slad-fill-rate', titulo: 'Fill Rate', grupo: GRUPOS_SLAD.INDICADORES, ab: 'FR' },

  { codigo: 'slad-maestro-productos', titulo: 'Consulta Maestro de Productos', icono: 'category' },

  { codigo: 'slad-puntos-entrega', titulo: 'Consulta de Puntos de Entrega', grupo: GRUPOS_SLAD.PUNTOS, ab: 'CPE' },
  { codigo: 'slad-restriccion-punto-contrato', titulo: 'Restricciones Punto/Contrato', grupo: GRUPOS_SLAD.PUNTOS, ab: 'PC' },
  { codigo: 'slad-restriccion-punto-producto', titulo: 'Restricciones Punto/Producto', grupo: GRUPOS_SLAD.PUNTOS, ab: 'PP' },
  { codigo: 'slad-restriccion-punto-vencimiento', titulo: 'Restricciones Punto/Vencimiento', grupo: GRUPOS_SLAD.PUNTOS, ab: 'PV' },
  { codigo: 'slad-restriccion-punto-producto-vencimiento', titulo: 'Restricciones Punto/Producto/Vencimiento', grupo: GRUPOS_SLAD.PUNTOS, ab: 'PPV' },
  { codigo: 'slad-restriccion-punto-producto-paletizado', titulo: 'Restricciones Punto/Producto/Paletizado', grupo: GRUPOS_SLAD.PUNTOS, ab: 'PPP' },
  { codigo: 'slad-restriccion-punto-agrupacion', titulo: 'Restricciones por Agrupación', grupo: GRUPOS_SLAD.PUNTOS, ab: 'PA' },

  { codigo: 'slad-pedido-selectivo', titulo: 'Ingreso de Pedido Selectivo', grupo: GRUPOS_SLAD.PEDIDOS, ab: 'PS' },
  { codigo: 'slad-pedido-retenidos', titulo: 'Ingreso de Pedidos de Productos Retenidos', grupo: GRUPOS_SLAD.PEDIDOS, ab: 'PR' },
  { codigo: 'slad-pedido-pick', titulo: 'Ingreso de Pedidos (PICK)', grupo: GRUPOS_SLAD.PEDIDOS, ab: 'PK' },

  { codigo: 'slad-reposicion-pallets', titulo: 'Reposicion Pallets', icono: 'autorenew' },
  { codigo: 'slad-stock-antiguo', titulo: 'Stock Antiguo en Inventario', icono: 'history' },
  { codigo: 'slad-ultimas-temperaturas', titulo: 'Últimas Temperaturas Registradas', icono: 'device_thermostat' },
  { codigo: 'slad-estadistica-temperaturas', titulo: 'Estadística de Temperaturas Registradas', icono: 'show_chart' }
];

/** Orden del menú: los grupos se dibujan en la posición de su primera opción. */
export const ORDEN_MENU_SLAD: Array<{ tipo: 'link' | 'sub', titulo: string, codigo?: string, icono?: string, hijos?: ReporteSlad[] }> = (() => {
  const salida: Array<{ tipo: 'link' | 'sub', titulo: string, codigo?: string, icono?: string, hijos?: ReporteSlad[] }> = [];
  const gruposPuestos = new Set<string>();
  for (const r of REPORTES_SLAD) {
    if (!r.grupo) {
      salida.push({ tipo: 'link', titulo: r.titulo, codigo: r.codigo, icono: r.icono });
    } else if (!gruposPuestos.has(r.grupo)) {
      gruposPuestos.add(r.grupo);
      salida.push({ tipo: 'sub', titulo: r.grupo, hijos: REPORTES_SLAD.filter(x => x.grupo === r.grupo) });
    }
  }
  return salida;
})();
